import DistributionBar from "pages/PanelPage/components/charts/DistributionBar/DistributionBar";

export default DistributionBar;
